import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormTextField, FormCheckbox, FormPanel } from '@eas/common-web';

export function RegistrationFields() {
  const intl = useIntl();

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="KS_O_REGISTRATIONS_FIELD_PANEL_TITLE"
          defaultMessage="Registrace"
        />
      }
    >
      <FormTextField
        name="email"
        required
        label={
          <FormattedMessage
            id="KS_O_REGISTRATIONS_FIELD_LABEL_EMAIL"
            defaultMessage="Email"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_REGISTRATIONS_FIELD_HELP_EMAIL',
          defaultMessage: ' ',
        })}
      />
      <FormTextField
        name="firstName"
        required
        label={
          <FormattedMessage
            id="KS_O_REGISTRATIONS_FIELD_LABEL_FIRST_NAME"
            defaultMessage="Jméno"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_REGISTRATIONS_FIELD_HELP_FIRST_NAME',
          defaultMessage: ' ',
        })}
      />
      <FormTextField
        name="lastName"
        required
        label={
          <FormattedMessage
            id="KS_O_REGISTRATIONS_FIELD_LABEL_LAST_NAME"
            defaultMessage="Příjmení"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_REGISTRATIONS_FIELD_HELP_LAST_NAME',
          defaultMessage: ' ',
        })}
      />
      <FormTextField
        name="phone"
        label={
          <FormattedMessage
            id="KS_O_REGISTRATIONS_FIELD_LABEL_PHONE"
            defaultMessage="Telefon"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_REGISTRATIONS_FIELD_HELP_PHONE',
          defaultMessage: ' ',
        })}
      />
      <FormTextField
        name="organisationName"
        required
        label={
          <FormattedMessage
            id="KS_O_REGISTRATIONS_FIELD_LABEL_ORGANISATION_NAME"
            defaultMessage="Název organizace"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_REGISTRATIONS_FIELD_HELP_ORGANISATION_NAME',
          defaultMessage: ' ',
        })}
      />
      <FormTextField
        name="organisationIc"
        required
        label={
          <FormattedMessage
            id="KS_O_REGISTRATIONS_FIELD_LABEL_ORGANISATION_IC"
            defaultMessage="IČ organizace"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_REGISTRATIONS_FIELD_HELP_ORGANISATION_IC',
          defaultMessage: ' ',
        })}
      />
      <FormCheckbox
        name="confirmed"
        disabled
        label={
          <FormattedMessage
            id="KS_O_REGISTRATIONS_FIELD_LABEL_CONFIRMED"
            defaultMessage="Potvrzena"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_REGISTRATIONS_FIELD_HELP_CONFIRMED',
          defaultMessage: ' ',
        })}
      />
    </FormPanel>
  );
}
